import { render, staticRenderFns } from "./ModalSuporteVisualizarGrupo.vue?vue&type=template&id=77869da6&scoped=true"
import script from "./ModalSuporteVisualizarGrupo.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteVisualizarGrupo.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteVisualizarGrupo.vue?vue&type=style&index=0&id=77869da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77869da6",
  null
  
)

export default component.exports